var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.488,0A27.5,27.5,0,1,1,8.052,8.054,27.5,27.5,0,0,1,27.488,0Zm-.174,33.19-4,11.065a2.2,2.2,0,0,1-1.154,1.266,2.237,2.237,0,0,1-2.975-1.074,2.264,2.264,0,0,1-.076-1.718L21.895,35a11.382,11.382,0,0,0,.523-1.79,18.746,18.746,0,0,0,.242-1.888c.107-1.132.183-2.358.242-3.535s.1-2.318.13-3.262c.04-1.177-.277-1.253-1.221-1.476l-.2-.045-8.054-1.517a2.237,2.237,0,1,1,.814-4.385l8.653,1.624c.345.031.68.072,1.034.112a25.736,25.736,0,0,0,3.212.237,36.2,36.2,0,0,0,4-.282c.4-.045.783-.094,1.163-.13l8.165-1.53a2.21,2.21,0,0,1,2.277,3.423v.027a2.237,2.237,0,0,1-1.436.935l-7.821,1.468c-.26.058-.492.1-.7.13-.814.139-1.217.21-1.168,1.369.036.846.139,1.857.273,2.913.157,1.239.362,2.555.577,3.758a18.344,18.344,0,0,0,.447,2.036c.179.608.353,1.23.622,1.978l2.734,7.561a2.237,2.237,0,1,1-4.2,1.526L28.186,33.212l-.447-.819-.447.8Zm.174-23.946A3.951,3.951,0,1,1,24.7,10.4a3.951,3.951,0,0,1,2.792-1.159Zm16.264,1.982a23.006,23.006,0,1,0,6.711,16.264,23.006,23.006,0,0,0-6.711-16.264Z",
    transform: "translate(0.004)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType1);
export default __webpack_public_path__ + "static/media/aioa-icon-type-1.3c974d4cfdc4def4d61a9227e06bb61d.svg";
export { ForwardRef as ReactComponent };